var _circle, _rect, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgValue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#6C63FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.9999,
    y: 15,
    width: 20,
    height: 19,
    fill: "#6C63FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 19.2012V23.8203L21.909 25.9171V24.5879H26.034V25.9171L35 23.8069V19.2012H13Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.034 30.0895H21.909V27.3238L13 25.2273V35.3614H35V25.2139L26.034 27.3238V30.0895Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0027 25.6201H22.9402V29.0576H25.0027V25.6201Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7514 16.0722C20.7518 15.9836 20.7847 15.9121 20.8421 15.8529C20.9012 15.7955 20.9727 15.763 21.061 15.7623H26.939C27.0272 15.763 27.0988 15.7955 27.1578 15.8529C27.2153 15.912 27.2478 15.9835 27.2485 16.0722V17.6191H29.1045V16.0722C29.1049 15.477 28.8608 14.9298 28.4701 14.5404C28.0814 14.1503 27.5342 13.9059 26.939 13.9063H21.061C20.4658 13.9059 19.9186 14.1503 19.5295 14.5404C19.1391 14.9298 18.8947 15.477 18.8954 16.0722V17.6191H20.7514V16.0722Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgValue);
export default __webpack_public_path__ + "static/media/value.347c69a79ff575eac64f9de1da201342.svg";
export { ForwardRef as ReactComponent };